<template>
  <div class="shipment-form-container">
    <div class="form-container">
      <div class="form-left-container">
        <BaseVinput v-model="$props.value.line1"
                    :label="$t('checkout.infoAndPayment.shipmentStreetLabel')"
                    :submitted="$props.formSubmitted"/>
        <label>{{ $t('checkout.infoAndPayment.shipmentPlaceLabel') }}</label>

        <v-select class="select-dropdown location-info"
                  :options="$props.cities"
                  v-model="$props.value.town"
                  :searchable="false"
                  label="name">
        </v-select>
      </div>
      <div>
        <div class="input-container">
          <div class="input">
            <BaseVinput v-model="$props.value.line2"
                        :label="$t('checkout.infoAndPayment.shipmentStreetNumberLabel')"
                        :submitted="$props.formSubmitted"
                        type="number"/>
          </div>
          <div class="input">
            <BaseVinput v-model="$props.value.postalCode"
                        :label="$t('checkout.infoAndPayment.shipmentPostalCodeLabel')"
                        :submitted="$props.formSubmitted"
                        type="number"/>
          </div>
        </div>
        <div class="text-area">
          <label for="remarks">{{ $t('checkout.infoAndPayment.shipmentRemarkLabel') }}</label>
          <textarea v-model="$props.value.remarks"
                    name="remarks"
                    id="remarks"
                    rows="3"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseVinput from '../../base/base-v-input'
import vSelect from 'vue-select'

export default {
  name: 'shipment-form',
  components: { BaseVinput, vSelect },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    cities: {
      type: Array,
      default: () => []
    },
    formSubmitted: Boolean
  }
}
</script>

<style scoped lang="scss">
.shipment-form-container {
  margin-top: 25px;
}

.form-container {
  @media (map_get($breakpoints, sm)) {
    display: flex;
    .form-left-container {
      width: 50%;
      margin-right: 40px;
    }
  }
}

.location-info {
  border: 1px solid $dark-grey;
  border-radius: 5px;
}

.input-container {
  display: flex;
  margin-top: 25px;
  @media (map_get($breakpoints, sm)) {
    margin-top: 0;
  }
}

.text-area {
  display: flex;
  flex-direction: column;
}

.place-label {
  color: $font-inactive;
  font-size: 14px;
}

.input {
  width: calc(50% - 2rem);

  &:first-child {
    margin-right: 4rem;
  }
}

</style>
